import { render, staticRenderFns } from "./CounterSVG.vue?vue&type=template&id=49d6a3c4&"
import script from "./CounterSVG.vue?vue&type=script&lang=js&"
export * from "./CounterSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports